// src/services/api.js
import axios from 'axios';

const API_BASE_URL = 'https://ethioinsider-backend.onrender.com/api';

export const fetchHomePageData = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/home`);
    return response.data;
  } catch (error) {
    console.error('Error fetching home page data:', error);
    throw error;
  }
};

export const fetchCategoryData = async (category) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/categories/${category}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching ${category} data:`, error);
    throw error;
  }
};

export const fetchTrendingTopics = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/trending`);
    return response.data;
  } catch (error) {
    console.error('Error fetching trending topics:', error);
    throw error;
  }
};